<template>
   <div class="html-panel" ref="panel">
     <div v-if="loading" class="html-panel-loading">
       <div class="loading-spinner"></div>
       <span>加载中...</span>
     </div>
     <iframe
       ref="iframe"
       :src="url"
       frameborder="0"
       :style="iframeStyle"
       scrolling="auto"
       @load="onLoad"
       v-show="!loading"
     ></iframe>
   </div>
</template>
<style scoped>
.html-panel {
  position: relative;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}
.html-panel iframe {
  display: block;
  width: 100%;
  border: none;
}
.html-panel-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #999;
  font-size: 15px;
  gap: 16px;
}
.loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e8e8e8;
  border-top-color: #1976D2;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
<script>
export default {
  name: "HtmlPanel",
  props: {
    url: {
      required: true
    }
  },
  data () {
    return {
      loading: true,
      iframeHeight: 1200
    }
  },
  computed: {
    iframeStyle() {
      return {
        height: this.iframeHeight + 'px'
      }
    }
  },
  mounted() {
    this.calcHeight();
    window.addEventListener('resize', this.calcHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcHeight);
  },
  methods: {
    calcHeight() {
      this.$nextTick(() => {
        var panel = this.$refs.panel;
        if (panel) {
          var rect = panel.getBoundingClientRect();
          var top = rect.top;
          var winH = window.innerHeight || document.documentElement.clientHeight;
          var available = winH - top - 20;
          this.iframeHeight = Math.max(available, 1200);
        }
      });
    },
    onLoad() {
      this.loading = false;
      this.calcHeight();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HtmlPanel.vue